import React, { useState, useEffect } from 'react';
import { withRouter, NavLink, useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
import { orderBy } from 'natural-orderby';
import { truncate } from 'underscore.string';
import SpringLoader from '../../../components/SpringLoader/SpringLoader.js';

import Searchbar from '../../../components/Searchbar';
import { newFetch, GET, PUT } from '../../../helpers/fetch';

const Communication = ({ history, ...props }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const tabs = ['Feedbacks', 'Instructions'];
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get('tab');

  const [activeTab, setActiveTab] = useState('Feedbacks');
  const [loading, setLoading] = useState(true);
  const [instructions, setInstructions] = useState([]);
  //const [feedbacks, setFeedbacks] = useState([]);
  const [filteredInstructions, setFilteredInstructions] = useState([]);
  const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);
  const [clients, setClients] = useState([]);

  const fetchInstructions = async () => {
    setLoading(true);
    let api_path = `/communication/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let instructionsData = response.data;
      setInstructions(instructionsData);
      setFilteredInstructions(instructionsData);
    }
    setLoading(false);
  };

  const fetchFeedbacks = async () => {
    let api_path = `/feedback/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let feedbackData = response.data;
      // setFeedbacks(feedbackData);
      setFilteredFeedbacks(feedbackData);
    }
  };

  const handleSearch = (e) => {
    let filtered = [...instructions].filter((event) => {
      return (
        event.title.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1
      );
    });

    setFilteredInstructions(filtered);
  };

  const fetchClients = async () => {
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
    }
  };

  useEffect(() => {
    if (tab) {
      setActiveTab('Feedbacks');

      // Remove tab parameter from the URL
      history.replace(location.pathname);
    }

    fetchInstructions();
    fetchFeedbacks();
  }, []);

  useEffect(() => {
    fetchInstructions();
    fetchFeedbacks();
    fetchClients();
  }, [clientID]);

  return (
    <div
      className="container-fluid"
      style={{
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '6rem',
      }}
    >
      <div className="border-bottom pb-2 py-2 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4" style={{ color: '#5156BE' }}>
          Communication
        </h6>
        {clients.enable_communication && activeTab === 'Instructions' && (
          <NavLink
            to={`/communication/instruction/add`}
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <button
              className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
              style={{ width: '200px' }}
            >
              Add New
            </button>
          </NavLink>
        )}
      </div>

      {clients.enable_communication ? (
        <>
          <div className="d-flex flex-row align-items-center justify-content-between pt-3 pb-1">
            <div className="d-flex">
              {tabs.map((tab) => (
                <div
                  key={tab}
                  className={
                    'text-center pb-3 me-4 ' +
                    (activeTab === tab ? ' text-brand' : ' text-muted')
                  }
                  onClick={() => setActiveTab(tab)}
                  style={
                    activeTab === tab
                      ? {
                          borderBottom: '5px #5156BE solid',
                          cursor: 'pointer',
                        }
                      : { cursor: 'pointer' }
                  }
                >
                  {tab} (
                  {tab === 'Instructions'
                    ? filteredInstructions.length
                    : tab === 'Feedbacks'
                    ? filteredFeedbacks.length
                    : 0}
                  )
                </div>
              ))}
            </div>

            <Searchbar search={(e) => handleSearch(e)} placeholder="Search" />
          </div>
          {activeTab === 'Instructions' && (
            <div className="table-responsive rounded shadow bg-white">
              <table className="table table-borderless mb-0">
                <thead className="border-bottom">
                  <tr>
                    <th className="py-3 text-muted fw-normal">ID</th>
                    <th className="py-3 text-muted fw-normal">Created By</th>
                    <th className="py-3 text-muted fw-normal">Client</th>
                    <th className="py-3 text-muted fw-normal">Title</th>
                    <th className="py-3 text-muted fw-normal text-center">
                      Date Created
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={5} className="text-center">
                        <div className="springloader-holder">
                          <SpringLoader />
                        </div>
                      </td>
                    </tr>
                  ) : filteredInstructions.length > 0 ? (
                    filteredInstructions.map((instruction) => (
                      <tr
                        className="border-bottom"
                        key={instruction.id}
                        onClick={() =>
                          history.push(
                            `/communication/instructions/${instruction.id}`
                          )
                        }
                      >
                        <td className="text-muted">
                          {instruction.communication_id}
                        </td>
                        <td className="text-muted">
                          {instruction.admin
                            ? `${instruction.admin.first_name} ${instruction.admin.last_name}`
                            : instruction.supervisor
                            ? `${instruction.supervisor.first_name} ${instruction.supervisor.last_name}`
                            : 'N/A'}
                        </td>
                        <td className="text-muted">
                          {instruction.client?.name || 'N/A'}
                        </td>
                        <td className="text-muted">
                          <div className="d-flex flex-column">
                            <strong>{truncate(instruction.title, 50)}</strong>
                            <div className="mt-1">
                              {truncate(instruction.description, 50)}
                            </div>
                          </div>
                        </td>
                        <td className="text-muted text-center">
                          {moment(instruction.createdAt).format('DD MMMM YYYY')}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center py-4">
                        No instructions found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
          {activeTab === 'Feedbacks' && (
            <div className="table-responsive rounded shadow bg-white">
              <table className="table table-borderless mb-0">
                <thead className="border-bottom">
                  <tr>
                    <th className="py-3 text-muted fw-normal">ID</th>
                    <th className="py-3 text-muted fw-normal">Created By</th>
                    <th className="py-3 text-muted fw-normal">Title</th>

                    <th className="py-3 text-muted fw-normal text-center">
                      Date Created
                    </th>
                    <th className="py-3 text-muted fw-normal text-center">
                      Last Updated
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredFeedbacks.length > 0 ? (
                    filteredFeedbacks.map((feedback) => (
                      <tr
                        key={feedback['Feedback.id']}
                        onClick={() =>
                          history.push(
                            `/communication/feedbacks/${feedback['Feedback.id']}`
                          )
                        }
                      >
                        <td className="text-muted">
                          {feedback['Feedback.feedback_id']}
                        </td>
                        <td className="text-muted">
                          {`${feedback.first_name} ${feedback.last_name}`}
                        </td>
                        <td className="text-muted">
                          <div className="d-flex flex-column">
                            {/* Title + Badge on the same row */}
                            <div className="d-flex align-items-center">
                              <strong className="mr-2">
                                {truncate(feedback['Feedback.title'], 50)}
                              </strong>

                              {feedback?.unread_count ? (
                                <span
                                  className="badge badge-pill ms-2"
                                  style={{
                                    backgroundColor: '#dc3545',
                                    color: 'white',
                                    fontSize: '11px',
                                    padding: '4px 8px',
                                  }}
                                >
                                  {feedback.unread_count}
                                </span>
                              ) : null}
                            </div>

                            {/* Description */}
                            <div className="mt-1">
                              {truncate(feedback['Feedback.description'], 50)}
                            </div>
                          </div>
                        </td>

                        <td className="text-muted text-center">
                          {moment(feedback['Feedback.createdAt']).format(
                            'DD MMMM YYYY'
                          )}
                        </td>
                        <td className="text-muted text-center">
                          {moment(feedback['Feedback.updatedAt']).format(
                            'DD MMMM YYYY'
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-muted text-center py-4">
                        No feedbacks found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </>
      ) : (
        <div className="text-muted pt-4">
          The client does not have access to this module.
        </div>
      )}
    </div>
  );
};

export default withRouter(Communication);
